<template>
	<div class="main">
		<common-header></common-header>
		<div class="container">
			<div class="first-container flex flex-start">
				<!-- 图片轮动放大镜 -->
				<div class="banner">
					<div class="choose" ref="choose" v-if="info.smpic.length">
						<div class="content" ref="content" @mousemove="handleMove" @mouseout="handleOut">
							<img :src="getWebPic(info.smpic[picIndex])" />
							<div class="shadow" ref="shadow"></div>
						</div>
						<div class="listdiv flex">
							<div class="arrow-left" @click="arrowLeft"><i class="el-icon-arrow-left"></i></div>
							<div class="listul" ref="listul">
								<ul id="listshow" ref="listshow">
									<li v-for="(pic, index) in info.smpic" :key="index" :class="{ selected: picIndex == index }" @mousemove="picIndex = index">
										<img :src="getWebPic(pic)" alt="" />
									</li>
								</ul>
							</div>
							<div class="arrow-right" @click="arrowRight"><i class="el-icon-arrow-right"></i></div>
						</div>
					</div>
					<div class="larger" ref="larger" v-if="info.smpic.length"><img :src="getWebPic(info.smpic[picIndex])" ref="big" /></div>
				</div>
				<!-- 商品信息 -->
				<div class="goodsInfo">
					<!-- 名称 -->
					<p class="p_title">{{ info.name }}</p>
					<!-- 价格 销量 评价 -->
					<div class="p_price flex">
						<div>
							<span>￥</span>
							<template v-if="isvip">
								<span class="price">{{ info.zhekouType == 1 ? (chooseForm.price * userInfo.vipZhekou).toFixed(2) : chooseForm.vipprice }}</span>
								<span class="del_price">¥{{ chooseForm.price ? chooseForm.price : '' }}</span>
							</template>
							<span v-else class="price">{{ chooseForm.price ? chooseForm.price : '' }}</span>
							<span class="coupon-tip" style="margin-left: 7px;" v-if="userInfo.vip && info.zhekouType == 1">{{ userInfo.vipZhekou * 10 }}折</span>
						</div>
						<div class="sale_comment flex">
							<div>
								<span class="bold">{{info.sales}}</span>
								<span>交易成功</span>
							</div>
							<div @click="toComment" style="cursor: pointer;">
								<span class="bold">{{info.comments.total}}</span>
								<span>累计评论</span>
							</div>
						</div>
					</div>
					<!-- 优惠 -->
					<div class="coupon flex" v-if="couponList.length">
						<span>优惠</span>
						<div class="coupon-list-show">
							<div class="coupon-item" v-for="(coupon,index) in couponList" :key="index">
								<template v-if="coupon.coupon_type==3">
									<!-- 折扣券 -->
									<span>商品折扣券，领券后{{coupon.youhui_bili}}折</span>
									<span class="get-coupon" @click="getCoupon">立即领取</span>
								</template>
								<template v-else>
									<span>商品{{coupon.youhui_price}}元满减券，满{{coupon.min_pay}}元可用</span>
									<span class="get-coupon" @click="getCoupon">立即领取</span>
								</template>
							</div>
						</div>
					</div>

					<!-- 参数 -->
					<div>
						<div v-for="(item, index) in specList" :key="index" class="attr-list">
							<span>{{ item.name }}</span>
							<div class="item-list">
								<template v-for="(childItem, childIndex) in specChildList">
									<span
										:key="childIndex"
										v-if="childItem.pid === item.id"
										:class="{ selected: childItem.selected }"
										@click="selectSpec(childIndex, childItem.pid)"
										class="tit"
									>
										{{ childItem.name }}
									</span>
								</template>
							</div>
						</div>
						<div>
							<div>数量</div>
							<el-input-number v-model="buynum" @change="buyNum" :min="1" :max="chooseForm.surplus"></el-input-number>
							<span>（库存{{ chooseForm.surplus }}件）</span>
						</div>
					</div>
					<!-- 购买 购物车 -->
					<div class="operate">
						<el-button type="text" :icon="favorite?'el-icon-star-on':'el-icon-star-off'" @click="toFavorite">{{favorite?'已收藏':'收藏商品'}}</el-button>
						<el-button type="warning" icon="el-icon-shopping-cart-1" @click="addCart">加入购物车</el-button>
						<el-button type="danger" @click="buyNow">立即购买</el-button>
					</div>
				</div>
			</div>
			<!-- 详情富文本 -->
			<el-tabs v-model="activeName" type="card" ref="content_comment" id="content_comment">
				<el-tab-pane label="商品详情" name="first"><div class="second-container" v-html="info.content"></div></el-tab-pane>
				<el-tab-pane :label="'评论（'+info.comments.total+'）'" name="second">
					<template v-if="info.comments.data.length">
						<div class="eva-box" v-for="(item, index) in info.comments.data" :key="index">
							<img class="portrait" :src="getWebPic(item.headerpic)" mode="aspectFill">
							<div class="right">
								<span class="name">{{ item.nickname }}</span>
								<div class="con">
									<div class="comment_pics" v-if="item.pics.length">
										<img v-for="(img, key) in item.pics" :key="key" :src="getWebPic(img)" class="comment_img">
									</div>
									<div v-html="item.comment_text"></div>
								</div>
								<div class="bot">
									<span class="attr">购买类型：{{ item.goods_params }}</span>
									<span class="time">{{ ctimeToDate(item.ctime) }}</span>
								</div>
							</div>
						</div>
						<div class="block">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handleCurrentChange"
								:current-page="thispage"
								:page-sizes="pageSizes"
								:page-size="pagesize"
								layout="total, sizes, prev, pager, next, jumper"
								:total="total"
							></el-pagination>
						</div>
					</template>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import { mapState,mapMutations, mapActions } from 'vuex';
import commonHeader from '../../components/common/commonHeader.vue';
export default {
	components: {
		commonHeader
	},
	data() {
		return {
			id: '',
			activeName: 'first',
			info: {
				id: '',
				smpic: [],
				comments: {
					total: 0,
					data: []
				},
				yunfeiModel: {
					id: '',
					else_fee: '[]',
					no_delivery_area: '[]'
				}
			}, //商品info
			commentList: [],
			thispage: 1,
			total: 0,
			pagesize: 15, //每页显示条数
			pageSizes: [15], //每页显示个数选择器
			specSelected: [], //选中参数
			favorite: false, //是否已收藏该商品
			desc: '', //富文本详情
			specList: [], //参数名
			specChildList: [], //参数列表
			paramsList: [], //每种规格
			chooseForm: [], //选中的规格数量等
			isvip: 0, //会员用户显示会员价
			couponList: [], //当前商品的可用优惠
			else_fee: [], //运费额外说明
			no_delivery_area: [], //不配送地区
			picIndex: 0,
			buynum: 1
		};
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		})
	},
	mounted() {
		console.log('商品id:', this.$route.query.id);
		let query = this.$route.query;
		this.id = query.id;
		this.isvip = this.userInfo.vip;
		this.getGoodsDetail();
	},
	methods: {
		...mapActions({
			exit: 'auth/logout'
		}),
		...mapMutations({
			setCartnum: 'user/setCartnum'
		}),
		buyNum(e) {
			console.log(e);
			this.chooseForm.buynum = e;
		},
		getGoodsDetail() {
			this.$emit('showLoading', true);
			this.$request
				.post('/home.goods/goodsDetail', {
					id: this.id,
					commentSize: this.pagesize
				})
				.then(res => {
					console.log(res.data);
					this.$emit('showLoading', false);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						res.data.info.content = res.data.info.content ? res.data.info.content.replace(/<img/gi, '<img class="rich-img" ') : '';
						this.total = res.data.info.comments.total;
						if (res.data.info.comments.total) {
							for (let i in res.data.info.comments.data) {
								res.data.info.comments.data[i].pics = JSON.parse(res.data.info.comments.data[i].pics);
							}
						}
						this.info = res.data.info;
						this.else_fee = JSON.parse(res.data.info.yunfeiModel.else_fee);
						this.no_delivery_area = JSON.parse(res.data.info.yunfeiModel.no_delivery_area);
						this.info.smpic = this.info.smpic.split(',');
						this.paramsList = res.data.paramsList;
						this.favorite = res.data.favorite;
						this.couponList = res.data.coupons;

						for (let i in this.paramsList) {
							if (this.paramsList[i].thumb) {
								this.paramsList[i].thumb = JSON.parse(this.paramsList[i].thumb);
							}
						}

						// 商品参数
						let param1s = [];
						for (let i in this.paramsList) {
							if (param1s.indexOf(this.paramsList[i].param1) == -1) {
								param1s = param1s.concat(this.paramsList[i].param1);
							}
						}
						for (let i in param1s) {
							param1s[i] = {
								pid: 1,
								name: param1s[i]
							};
						}
						param1s[0].selected = true;
						if (this.info.goodsType == 1) {
							let param2s = [];
							for (let i in this.paramsList) {
								if (param2s.indexOf(this.paramsList[i].param2) == -1) {
									param2s = param2s.concat(this.paramsList[i].param2);
								}
							}
							for (let i in param2s) {
								param2s[i] = {
									pid: 2,
									name: param2s[i]
								};
							}
							param2s[0].selected = true;
							this.specChildList = param1s.concat(param2s);
							this.specList = [
								{
									id: 1,
									name: '颜色'
								},
								{
									id: 2,
									name: '尺码'
								}
							];
						} else {
							this.specChildList = param1s;
							this.specList = [
								{
									id: 1,
									name: '参数'
								}
							];
						}
						//规格 默认选中第一条
						this.specList.forEach(item => {
							for (let cItem of this.specChildList) {
								console.log(JSON.stringify(cItem));
								if (cItem.pid === item.id) {
									this.$set(cItem, 'selected', true);
									this.specSelected.push(cItem);
									break; //forEach不能使用break
								}
							}
						});
						console.log('specChildList', this.specChildList);
						this.chooseGoodsParams();
					}
				})
				.catch(err => {
					console.log(err);
					this.$emit('showLoading', false);
				});
		},
		// 获取商品评价
		getGoodsComment(){
			this.$emit('showLoading',true);
			this.$request
				.post('/home.goods/getCommentList', {
					thispage: this.thispage,
					pagesize: this.pagesize,
					goods_id:this.id,
					buyType:''
				})
				.then(res => {
					console.log(res.data);
					this.$emit('showLoading',false);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.info.comments.data = res.data.data;
						this.total = res.data.total;
					}
				})
				.catch(err => {
					console.log(err);
					this.$emit('showLoading',false);
				});
		},
		// 选择参数
		chooseGoodsParams() {
			if (this.info.goodsType != 1) {
				this.specSelected[1] = {
					pid: 2,
					name: null,
					selected: true
				};
			}
			// console.log(JSON.stringify(this.specSelected));
			// console.log(this.paramsList);
			for (let i in this.paramsList) {
				if (this.specSelected[0].name == this.paramsList[i].param1 && (this.specSelected[1].name == this.paramsList[i].param2 || this.paramsList[i].param2 == '')) {
					console.log(JSON.stringify(this.paramsList[i]));
					this.chooseForm = this.paramsList[i];
					this.chooseForm.buynum = 1;
					if (this.chooseForm.thumb) {
						console.log(this.chooseForm.thumb);
						this.info.smpic = this.chooseForm.thumb;
						this.swiperCurrent = 0;
					}
					return;
				}
			}
		},
		//选择规格
		selectSpec(index, pid) {
			console.log(index, pid);
			let list = this.specChildList;
			list.forEach(item => {
				if (item.pid === pid) {
					this.$set(item, 'selected', false);
				}
			});

			this.$set(list[index], 'selected', true);
			//存储已选择
			/**
			 * 修复选择规格存储错误
			 * 将这几行代码替换即可
			 * 选择的规格存放在specSelected中
			 */
			this.specSelected = [];
			list.forEach(item => {
				if (item.selected === true) {
					this.specSelected.push(item);
				}
			});
			console.log(this.specChildList);
			console.log(this.specSelected);
			if (pid == 1) {
				this.picIndex = 0;
			}
			this.chooseGoodsParams();
		},
		// 获取元素到文档区域的坐标
		getPosition: function(element) {
			var dc = document,
				rec = element.getBoundingClientRect(),
				x = rec.left, // 获取元素相对浏览器视窗window的左、上坐标
				y = rec.top;
			// 与html或body元素的滚动距离相加就是元素相对于文档区域document的坐标位置
			x += dc.documentElement.scrollLeft || dc.body.scrollLeft;
			y += dc.documentElement.scrollTop || dc.body.scrollTop;
			return {
				left: x,
				top: y
			};
		},
		// 图片放大镜
		handleMove(evt) {
			var larger = this.$refs.larger;
			var shadow = this.$refs.shadow;
			var big = this.$refs.big;
			var pos = this.getPosition(this.$refs.choose);
			var shadowRect = shadow.getBoundingClientRect();
			var bigRect = big.getBoundingClientRect();
			var contentRect = this.$refs.content.getBoundingClientRect();
			var maxX = contentRect.width - shadowRect.width;
			var maxY = contentRect.height - shadowRect.height;

			var X = evt.pageX - pos.left - shadowRect.width / 2;
			var Y = evt.pageY - pos.top - shadowRect.height / 2;

			if (X <= 0) {
				X = 0;
			}
			if (X >= maxX) {
				X = maxX;
			}
			if (Y <= 0) {
				Y = 0;
			}
			if (Y >= maxY) {
				Y = maxY;
			}
			// 防止遮罩层粘滞，跟随鼠标一起滑出大图位置
			var bigX = (X * bigRect.width) / contentRect.width;
			var bigY = (Y * bigRect.height) / contentRect.height;
			//  bigX / bigW = X / contentW,主图和遮罩层之间存在两倍关系，放大图和原图之间也有两倍关系
			shadow.style.left = X + 'px';
			shadow.style.top = Y + 'px';

			// console.log(X, Y, bigX, bigY);

			big.style.left = -bigX + 'px';
			big.style.top = -bigY + 'px';

			larger.style.display = 'block';
			shadow.style.display = 'block';
		},
		// 移出
		handleOut(evt) {
			var larger = this.$refs.larger;
			var shadow = this.$refs.shadow;
			larger.style.display = 'none';
			shadow.style.top = '-1000px';
		},
		// 图片列表向左
		arrowLeft() {
			let marginleft = this.$refs.listshow.style.marginLeft ? this.$refs.listshow.style.marginLeft : 0;
			marginleft = parseInt(marginleft);
			if (marginleft >= 0) {
				console.log('已经移动到最左侧了');
			} else {
				let listshowWidth = this.$refs.listshow.scrollWidth;
				let widthStep = this.$refs.listul.clientWidth;
				if (Math.abs(marginleft) > widthStep) {
					marginleft += widthStep;
					// 超出一屏
					this.$refs.listshow.style.marginLeft = marginleft + 'px';
				} else {
					this.$refs.listshow.style.marginLeft = '0px';
				}
			}
		},
		// 图片向右
		arrowRight() {
			let marginleft = this.$refs.listshow.style.marginLeft ? this.$refs.listshow.style.marginLeft : 0;
			marginleft = parseInt(marginleft);
			let listshowWidth = this.$refs.listshow.scrollWidth;
			let widthStep = this.$refs.listul.clientWidth;
			if (listshowWidth + marginleft > widthStep) {
				marginleft -= widthStep;
				this.$refs.listshow.style.marginLeft = marginleft + 'px';
			} else {
				return false;
			}
		},
		// 评论每页条数变换
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.pagesize = val;
			this.getGoodsComment();
		},
		// 评论翻页
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.thispage = val;
			this.getGoodsComment();
		},
		// 点击顶部价格右侧评论锚点跳转到评论列表
		toComment(){
			this.activeName = 'second';
			this.$el.querySelector('#content_comment').scrollIntoView();
		},
		// 领取优惠券
		getCoupon(){
			if(!this.userInfo.id){
				this.$router.push('/login');
			}
		},
		// 加入购物车
		addCart(){
			console.log(this.userInfo.id);
			if(!this.userInfo.id){
				this.$router.push('/login');
			}else{
				if (this.chooseForm.surplus <= 0) {
					this.$api.msg('所选商品类别库存不足');
					return;
				}
				this.$emit('showLoading',true);
				this.$request
					.post('/home.cart/addCart', {
						id: this.chooseForm.id,
						num: this.chooseForm.buynum,
						userid: this.userInfo.id? this.userInfo.id: '',
						token: this.userInfo.token? this.userInfo.token: ''
					})
					.then(res => {
						console.log(res.data);
						this.$emit('showLoading',false);
						if (res.data.status == 0) {
							this.$message.error(res.data.msg);
							if (res.data.admin_err == 'userinfo_error') {
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else {
							this.$message.success(res.data.msg);
							this.setCartnum(res.data.cart_num);
						}
					})
					.catch(err => {
						console.log(err);
						this.$emit('showLoading',false);
					});
			}
		},
		// 立即购买
		buyNow(){
			if(!this.userInfo.id){
				this.$router.push('/login');
			}else{
				if (this.chooseForm.surplus <= 0) {
					this.$api.msg('所选商品类别库存不足');
					return;
				}
				var info = this.chooseForm;
				info.name = this.info.name;
				info.smpic = this.info.smpic[0];
				info.number = this.chooseForm.buynum;
				info.zhekouType = this.info.zhekouType;
				info.yunfeiModel = this.info.yunfeiModel;
				info.parentsId = [this.info.first_parent_id,this.info.second_parent_id,this.info.parent_id];
				var total = 0;
				if (this.isvip) {
					if(this.info.zhekouType == 1){
						total = Number((info.price * this.userInfo.vipZhekou * info.number *100 / 100).toFixed(2));
					}else{
						total = Number((info.vipprice * info.number *100 / 100).toFixed(2));
					}
				} else {
					total = Number((info.price * info.number *100 / 100).toFixed(2));
				}
				info.realpay = total;
				var goodsData = [];
				goodsData.push(info);
				localStorage.setItem('buyList_'+this.userInfo.id,JSON.stringify(goodsData));
				localStorage.setItem('buyTotal_'+this.userInfo.id,total);
				this.$router.push('/order/createOrder');
			}
		},
		//收藏
		toFavorite() {
			this.$request.post('/home.user/goodsCollect',{
				user_id: this.userInfo.id,
				goods_id: this.info.id,
				favorite: !this.favorite,
				userid: this.userInfo.id ? this.userInfo.id : '',
				token: this.userInfo.token ? this.userInfo.token : ''
			})
			.then(res=>{
				if (res.data.status == 0) {
					this.$message.error(res.data.msg);
					if (res.data.admin_err == 'userinfo_error') {
						this.exit().then(res => {
							console.log(res);
							if (res.actionStatus == 1) {
								this.$router.push('/login');
							}
						});
					}
				} else {
					this.$message.success(res.data.msg);
					this.favorite = !this.favorite;
				}
			})
			.catch(err=>{
				
			})
		},
	}
};
</script>

<style lang="scss" scoped>
.text-red {
	color: red;
}
.banner {
	position: relative;
	width: 400px;
	.choose {
		width: 400px;
		height: 600px;
		float: left;
	}

	.content {
		width: 400px;
		height: 400px;
		position: relative;
		cursor: move;
	}

	.content img {
		width: 400px;
		height: 400px;
	}
	div.listdiv {
		margin-top: 20px;
		cursor: pointer;
		position: relative;
		.arrow-left,
		.arrow-right {
			vertical-align: middle;
			font-size: 35px;
			line-height: 100px;
			font-weight: bold;
			&:hover {
				color: brown;
				background: rgba($color: #ababab, $alpha: 0.3);
			}
		}
		div.listul {
			height: 104px;
			overflow-x: hidden;
			width: calc(100% - 70px);
			#listshow {
				display: flex;
				flex-flow: row nowrap;
				margin-left: 0;
				transition: all 0.5s;
				li {
					width: 98px;
					height: 100px;
					float: left;
					border: 1px solid #f7f7f7;
					margin-right: 10px;
					img {
						width: 98px;
						height: 100px;
					}
					&:last-child {
						margin-right: 0;
					}
				}
				.selected {
					border-color: brown;
				}
			}
		}
	}

	.larger {
		width: 600px;
		height: 600px;
		position: absolute;
		top: 0;
		left: 420px;
		float: left;
		overflow: hidden;
		display: none;
		z-index:9;
	}

	.larger img {
		width: 800px;
		height: 800px;
		position: absolute;
		left: 0;
		top: 0;
	}

	.shadow {
		width: 200px;
		height: 200px;
		background-color: rgba(145, 200, 200, 0.4);
		position: absolute;
		left: 0;
		top: 0;
		z-index: 10;
		display: none;
	}
}
.goodsInfo {
	min-width: 560px;
	text-align: left;
	padding: 0 30px  15px 30px;
	box-sizing: border-box;
	div,p{
		margin-bottom: 10px;
	}
	.del_price{
		text-decoration: line-through;
		color: gray;
		margin-left: 7px;
	}
	.p_title{
		margin-bottom: 10px;
		font-size: 18px;
		font-weight: bold;
	}
	.p_price{
		color: #f24b72;
		background-color: #F2DEDE;
		line-height: 60px;
		height: 60px;
		padding: 0 15px;
		font-weight: bold;
		.price{
			font-size: 20px;
		}
		.sale_comment{
			font-weight: 500;
			line-height: 30px;
			text-align: center;
			font-size: 15px;
			color: #4b4b4b;
			>div:last-child{
				margin-left: 15px;
				&:hover{
					color: #f24b72;
				}
			}
			span{
				display: block;
			}
			.bold{
				font-weight: bold;
			}
		}
	}
	.attr-list {
		display: flex;
		flex-direction: column;
		padding-top: 30upx;
		padding-left: 10upx;
	}
	.item-list {
		padding: 10px 0 0;
		display: flex;
		flex-wrap: wrap;
		cursor: pointer;
		.tit {
			display: flex;
			align-items: center;
			justify-content: center;
			background: #eee;
			margin-right: 10px;
			margin-bottom: 10px;
			border-radius: 5px;
			min-width: 60upx;
			height: 60upx;
			padding: 5px 10px;
			&.selected {
				background: #f7cfd7;
				color: #fa436a;
			}
		}
	}
	.coupon{
		padding: 5px 10px;
		font-size: 14px;
		background-color: #fef1ee;
		.coupon-list-show{
			padding: 0 15px;
			flex:1;
			.get-coupon{
				margin-left: 15px;
				color: #fa436a;
				cursor: pointer;
			}
			.coupon-item{
				// background-color: transparent;
			}
		}
	}
}
.eva-box {
	display: flex;
	padding: 10px 0;
	border-bottom: 1px solid #E4E7ED;
	.portrait {
		flex-shrink: 0;
		width: 60px;
		height: 60px;
		border-radius: 100px;
		border: 1px solid #E4E7ED;
	}
	.right {
		flex: 1;
		display: flex;
		flex-direction: column;
		text-align: left;
		padding-left: 13px;
		.con {
			padding: 10px;
		}
		.bot {
			display: flex;
			justify-content: flex-end;
			font-size: 13px;
			line-height: 25px;
			color: gray;
			.attr{
				margin-right: 10px;
			}
		}
	}
	
}

</style>
